import { EMAIL } from 'constants/messageMediums';
import BaseSendEditor, { BaseSendEditorProps } from '../BaseSendEditor';

export const SendEmailEditor = (props: BaseSendEditorProps) => {
  return (
    <BaseSendEditor
      shouldShowSTO
      shouldShowQuietHours
      shouldShowRateLimit
      shouldShowDeliverySectionHeader
      {...props}
      messageMedium={EMAIL}
    />
  );
};
